import { createSelector } from 'reselect';

import { ReduxCalendarPlanStoreState } from './typings';

const storeStateSelector = (store: ReduxCalendarPlanStoreState) => store.calendarPlan;

export const getThemeActivities = createSelector([storeStateSelector], (store) => store.themeActivities);

export const getThemeActivitiesLoadingStatus = createSelector(
    storeStateSelector,
    (store) => store.themeActivitiesLoadingStatus
);
